import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MeningButtonComponent } from './mening-button.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        MeningButtonComponent,
    ],
    exports: [
        MeningButtonComponent,
    ],
})
export class MeningButtonModule {
}
